<template>
  <div id="selectMemberWindow">
    <el-dialog title="选择显示人员" :visible.sync="dialogVisible" width="1100px">
      <div class="dialog-body">
        <div>
          <el-input placeholder="请输入关键字" v-model="search" style="width: 250px;float: right;"></el-input>
        </div>
        <div class="table eb-table">
          <el-table :data="tables" :stripe="true">
            <el-table-column width="70">
              <template slot-scope="scope">
                <template v-if="companyTeamList.indexOf(scope.row.userId + '') != -1">
                  <span class="selectedMember">已选择</span>
                </template>
                <template v-else>
                  <input
                    type="radio"
                    @click="checkedMyRadio(scope.row.userId)"
                    name="checkUserId"
                    :value="scope.row.userId"
                  >
                </template>
              </template>
            </el-table-column>
            <el-table-column sortable property="showName" label="用户名" width="100"></el-table-column>
            <el-table-column sortable property="trueName" label="姓名" width="100"></el-table-column>
            <el-table-column sortable property="departName" label="部门"></el-table-column>
            <el-table-column sortable property="userPhone" label="手机" width="120"></el-table-column>
            <el-table-column sortable property="userEmail" label="邮件" width="180"></el-table-column>
            <el-table-column sortable property="roleNames" label="角色"></el-table-column>
            <el-table-column sortable property="status" label="状态" width="120">
              <template slot-scope="scope">{{scope.row.status|userStatus}}</template>
            </el-table-column>
          </el-table>
          <eb-pagination @current-change="onPageChange" :total="recordsTotal"/>
        </div>
      </div>
      <div
        class="dialog-footer eb-button-group"
        slot="footer"
        style="border-top: 1px solid #e5e5e5;"
      >
        <el-button
          :loading="buttonLoading"
          @click="closeMyDialog()"
          class="eb-button-group-btn eb-button-orange eb-button-big"
        >取消</el-button>
        <el-button
          :loading="buttonLoading"
          @click="editShowMember()"
          class="eb-button-group-btn eb-button-orange eb-button-big"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getUserInfoList } from '@/services/user/user-service';
import { updateDepartment } from '@/services/org/depart-service';
import eventBus from '@/plugins/event-bus';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';

export default {
  name: 'selectMemberWindow',
  components: {
    ebPagination
  },
  props: {
    user: {},
    orgInfo: {}
  },
  data() {
    return {
      buttonLoading: false,
      dialogVisible: false,
      editMember: {},
      pageData: null,
      recordsTotal: null,
      companyTeamList: null,
      checkedUserId: '',
      listRequestData: {
        length: 10,
        start: 0
      },
      search: ''
    };
  },
  created() {
    eventBus.$on('showSelectMemberWindow', params => {
      this.initSelectMemberTable();
      let companyTeam = this.orgInfo.companyTeam;
      this.companyTeamList = companyTeam && companyTeam !== '' ? companyTeam.split(',') : ',,,,';
      this.editMember.index = params.editIndex;
      this.dialogVisible = true;
    });
    eventBus.$on('removeMember', params => {
      this.removeMember(params);
    });
  },
  computed: {
    tables: function() {
      var search = this.search;
      if (search) {
        return this.pageData.filter(function(dataNews) {
          return Object.keys(dataNews).some(function(key) {
            return (
              String(dataNews[key])
                .toLowerCase()
                .indexOf(search) > -1
            );
          });
        });
      }
      return this.pageData;
    }
  },
  methods: {
    async initSelectMemberTable() {
      try {
        let { data } = await getUserInfoList({
          orgId: this.user.orgId,
          inStatus: '0,1'
        });
        if (data.returnCode === '01') {
          this.pageData = data.data;
          this.recordsTotal = data.data.length;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 分页
    onPageChange(pageNum) {
      let pageRow = (pageNum - 1) * this.listRequestData.length;
      this.listRequestData.start = pageRow;
      this.initSelectMemberTable();
    },
    checkedMyRadio(data) {
      this.checkedUserId = data;
    },
    async editShowMember() {
      let selectedData = this.checkedUserId;
      if (selectedData == null || selectedData === '') {
        this.$message.info('请选择要显示的团队成员');
        return;
      }
      this.companyTeamList[this.editMember.index] = selectedData;

      var params = {
        departId: this.user.orgId,
        departName: this.orgInfo.departName,
        companyTeam: this.companyTeamList.join(',')
      };
      params.isSendMsg = false; // 是否发送消息给部门成员
      try {
        let result = await updateDepartment(params);
        result = result.data;
        if (result.returnCode === '01') {
          this.orgInfo.companyTeam = this.companyTeamList.join(',');
          eventBus.$emit('refreshOrgTeamMember', this.orgInfo.companyTeam);
          this.dialogVisible = false;
        } else {
          this.$message.error('编辑显示团队成员失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async removeMember(data) {
      var companyTeam = this.orgInfo.companyTeam;
      this.companyTeamList = companyTeam && companyTeam !== '' ? companyTeam.split(',') : ',,,,';
      this.companyTeamList[data.removeIndex] = '';
      companyTeam = this.companyTeamList.join(',');
      var params = {
        departId: this.user.orgId,
        departName: this.orgInfo.departName,
        companyTeam: companyTeam
      };
      params.isSendMsg = false; // 是否发送消息给部门成员
      try {
        let result = await updateDepartment(params);
        result = result.data;
        if (result.returnCode === '01') {
          this.$message.success('取消团队成员显示成功！');
          this.orgInfo.companyTeam = companyTeam;
          eventBus.$emit('refreshOrgTeamMember', this.orgInfo.companyTeam);
        } else {
          this.$message.error('取消团队成员显示失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    closeMyDialog() {
      this.dialogVisible = false;
    }
  }
};
</script>
<style scoped lang="less">
.selectedMember {
  color: #fb5b3b !important;
}
</style>
